import { Router } from './routes/Router'
import { Toaster } from '@/components/ui/sonner'

function App() {
  return (
    <>
      <Router />
      <Toaster />
    </>
  )
}

export default App
